(function ($) {
  "use strict";
  EASY.projectSearchDroppable = {
    dropActions: {},
    blocked: false,
    register: function (name, params) {
      this.dropActions[name] = params;
    },
    init: function ($target, itemParams) {
      this.enhanceItemParams(itemParams);
      if (!this.dropActions[itemParams.type]) return;
      var self = this;
      $target.append('<span class="easy-search-dragger icon icon-draggable"></span>');
      $target.on("mousedown.searchDrag", function (event) {
         if (event.which != 2) {
          if (event.which === 1 && !event.ctrlKey){
            $target.closest(".ui-autocomplete").addClass("easy-search__menu--force_display");
          }
          else{
            $(".easy-search__menu--force_display").removeClass("easy-search__menu--force_display");
          }
        }
      });
      $target.draggable(
          {
            handle: "span.easy-search-dragger",
            cursor: "move",
            cursorAt: {top: 25, left: 60},
            revert: "invalid",
            helper: "clone",
            placeholder: {
              element: function (currentItem) {
                return $("<li/>").attr({"class": "ui-state-highlight icon icon-import easy-search-placeholder"}).text(text)[0];
              },
              update: function (container, p) {
                return;
              }
            },
            tolerance: "pointer",
            forcePlaceholderSize: true,
            appendTo: document.body,

            start: function (event, ui) {
              var itemData = itemParams.item.issue_id;
              // var itemData = $target.data().uiAutocompleteItem.issue_id;
              $('.easy-dropper-target').each(function (index, item) {
                var dropType = $(item).attr('data-drop-action');
                if (itemParams.type !== dropType) return;
                var zoneData = $(item).data();
                var zone;
                var params = self.dropActions[dropType];
                if (!params) {
                  return;
                }
                //
                zone = createEasyDropZone(item, params.label);
                if (zone) {
                  zone.droppable({
                    hoverClass: 'easy-target-dropzone-hover',
                    drop: function (event, ui) {
                      if (params.callback && typeof params.callback === 'function') {
                        params.callback(zone, zoneData, itemData);
                      } else {
                        alert("Upadlo ti to !");
                      }
                    }
                  });
                }
              });
            },
            stop: function (event, ui) {
              $('.easy-target-dropzone').remove();
              $(".easy-search__menu--force_display").removeClass("easy-search__menu--force_display");
            }
          });
    },
    /**
     *
     * @param {{item:{issue_id?:int,project_id?:int},type?:string}} params
     */
    enhanceItemParams: function (params) {
      if (params.item.issue_id) {
        params.type = "issue";
      } else if (params.item.project_id) {
        params.type = "project";
      }
    }
  };

}(jQuery));
